import { useQueryWithContext, villusClient } from '@utils/villus';
import { MediaPartnerNotices } from 'types/sanity/marketing-components';
import { MediaPartnerNoticesQuery } from './queries/media-partner-notices';
import { SanityGraphQLResponse } from 'types/sanity';

type SanityMediaPartnerNoticesResponse = SanityGraphQLResponse<MediaPartnerNotices, 'allMediaPartnerNotices'>;

export async function getMediaPartnerNotices(context?: string): Promise<MediaPartnerNotices | null> {
	const { data } = await useQueryWithContext<SanityMediaPartnerNoticesResponse>({
		client: villusClient,
		query: MediaPartnerNoticesQuery,
		baseTag: 'media_partner_notices',
		contextTag: context
	}).execute();

	return data?.allMediaPartnerNotices[0] ?? null;
}
